exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer{background-color:#1b2246;position:relative;color:white;z-index:10}.footer .footer-wrapper{width:100%}.footer-wrapper{display:flex;justify-content:space-between;gap:10px}.fixed-footer{background-color:#1b2246;bottom:0px;width:100%;color:white;z-index:10}.sceasypay-footer{background-color:#624fa1}\n", ""]);

